import {useEffect, useRef, useState} from "react";
import {MissingContent, StudentAdminGrid} from "./StudentAdmin.styled";
import {useStore} from "@store/appStore";
import db from "@utils/db";
import RainbowLoader from "@components/Loaders/RainbowLoader";
import { useI18n } from '@i18n/useI18n';
import Student from "@components/StudentAdmin/Student/Student";
import Courses from "@components/StudentAdmin/Courses";
import LogList from "@components/StudentAdmin/LogList";
import StudentAdminText from "@components/StudentAdmin/StudentAdminText/StudentAdminText";

interface IProps{

}

const StudentAdmin = (props:IProps) =>{
    const i18n = useI18n();
    const { callNameSetting, adminSelection, adminSelectedStudent, clientSettings, systemSettings} = useStore();
    const [student, setStudent] = useState(null)
    const [log, setLog] = useState(null)

    useEffect(() => {
        getLog()
    }, [])


    useEffect(() => {
        if (adminSelection && adminSelection.type === "STUDENT" && (student && student.id !== adminSelection.id || student === null))
        {
            getStudent()

        }
        else if(!adminSelection || adminSelection.type === null && student && student.id !== null)
        {
            setStudent(null)
        }
    }, [adminSelection])


    const getLog = async () => {
        db.GetStudentRosterLog().then(data => {
            setLog(data)
        })
    }


    const getStudent = async () => {
        db.GetStudentRoster(adminSelection.val).then(data => {
            setStudent({id: adminSelection.id, name: adminSelectedStudent.firstname, username: adminSelection.val, data: data})
        })
    }

    return (
        <StudentAdminGrid frontPage={!(adminSelection && adminSelection.type === "STUDENT" && student)}>
            {adminSelection && adminSelection.type === "STUDENT" && student?
                <>
                    <Student studentInfo={student} />
                    <Courses getLog={getLog} getDataFunction={getStudent} data={student.data} />
                </>
                :
                <>
                    <MissingContent><span>{i18n.t("use-search-adminpage")}</span></MissingContent>
                </>
            }
        </StudentAdminGrid>
    )
}

export default StudentAdmin;